import ChevRightIcon from '../icons/ChevRightIcon'
import type { IconProps } from '../icons/types'
import { HighlightedIcon } from './HighlightedIcon'
import { Text } from './Text'

export interface MetricCardProps {
	icon: React.FC<IconProps>
	title: string
	value: string
	onClick?: () => void
}

export const MetricCard = ({ icon, title, value, onClick }: MetricCardProps) => {
	return (
		<button
			type='button'
			className='flex w-full text-start p-6 border border-neutral-200 bg-neutral-0 rounded-lg items-center gap-x-6 cursor-pointer hover:bg-primary-50'
			onClick={onClick}>
			<HighlightedIcon icon={icon} />
			<div>
				<Text variant='xsmall' className='mb-1'>
					{title}
				</Text>
				<Text variant='large' weight='semibold'>
					{value}
				</Text>
			</div>
			<ChevRightIcon className='ml-auto self-start text-primary-600' />
		</button>
	)
}
